import { render, staticRenderFns } from "./LayoutComponentSettings.vue?vue&type=template&id=02d43576&"
import script from "./LayoutComponentSettings.vue?vue&type=script&lang=js&"
export * from "./LayoutComponentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports